import { render } from "./PersonLine.vue?vue&type=template&id=75853b4f&scoped=true&ts=true"
import script from "./PersonLine.vue?vue&type=script&lang=ts"
export * from "./PersonLine.vue?vue&type=script&lang=ts"

import "./PersonLine.vue?vue&type=style&index=0&id=75853b4f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75853b4f"]])

export default __exports__